module.exports = __webpack_public_path__ + "static/img/fitPlanBan1.f66c153.png";


//////////////////
// WEBPACK FOOTER
// ./src/static/images/solution/fitPlanBan1.png
// module id = P7fh
// module chunks = 1